<template>
    <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          {{ $t('Views.Privacy.title') }}
        </v-card-title>
        <v-card-text>
            <p>{{ $t('Views.Privacy.text') }}</p>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>

<style>

</style>
